var defaultWindow = {};
var getWindow = (function () {
  return typeof window === 'undefined' ? defaultWindow : window;
});

export { getWindow as default };
